import type { PluginListenerHandle } from '@capacitor/core';
import { registerPlugin } from '@capacitor/core';

export interface UploadFileOptions {
  path: string;
  uploadUrl: string;
  fileName: string;
  mimeType: string;
  headers?: Record<string, string>;
  projectId?: number;
  fileFolderId?: number;
  qaAnswerBody?: number;
  address?: Record<string, string>; //ios cant handle undefined in the type, so that is why it's a record and not the GeoLocationDTO
  comment?: string;
  isCompressible: boolean;
}

export interface UploadFileSuccess {
  success: boolean;
  response: string;
  code: number;
}

export interface UploadProgress {
  sent: number;
  total: number;
  ratio: number;
}

export interface FileUploadPlugin {
  uploadFile(options: UploadFileOptions): Promise<UploadFileSuccess >;
  addListener(
    eventName: 'progress',
    listener: (data: UploadProgress) => void,
  ): Promise<PluginListenerHandle> & PluginListenerHandle;
}

const FileUpload = registerPlugin<FileUploadPlugin>('FileUpload');

export default FileUpload;
